export const endpointInfo = "https://gbfs.citibikenyc.com/gbfs/en/station_information.json";
export const endpointStatus = "https://gbfs.citibikenyc.com/gbfs/en/station_status.json";
export const endpointAddress = "https://api.nyc.gov/geo/geoclient/v1/address.json";